(function (window, $) {
  'use strict';
  if (!$) return;

  /*
  #=============================================================
  # 商品画像ギャラリー（ページ側サムネクリックでMain差し替え）
  #=============================================================
  */
  (function ($) {
    $(function () {
      function preload(src, onload, onerror) {
        var img = new Image();
        img.onload = function () { onload && onload(); };
        img.onerror = function () { onerror && onerror(); };
        img.src = src;
      }

      // 旧DOM参照のキャッシュは持たない（部分差し替え対策）

      // サムネクリックは委譲バインド（部分差し替え後も有効）
      $(document).off('click.galleryswap').on('click.galleryswap', '#Thumbnail .ThumbBtn', function (e) {
        e.preventDefault();

        var $btn = $(this);
        var mainUrl = $btn.data('main');
        var zoomUrl = $btn.data('zoom');
        var memo = ($btn.data('memo') || '').toString();
        var alt = ($btn.data('alt') || '').toString();

        // 最新DOMからメイン画像／メモ要素を取得
        var $main = $('#MainPhoto');
        var $memo = $('#PhotoMemo');
        var currentSrc = $main.attr('src') || '';

        // アクティブ表示を更新
        $('#Thumbnail .ThumbBtn').removeClass('is-active').attr('aria-current', 'false');
        $btn.addClass('is-active').attr('aria-current', 'true');

        // メイン画像の差し替え（プリロード＋フォールバック）
        preload(
          mainUrl,
          function () { $main.attr('src', mainUrl).attr('alt', alt); },
          function () { $main.attr('src', currentSrc).attr('alt', ''); }
        );

        // 拡大リンクのhrefも同期
        try {
          var $link = $('#MainPhotoLink');
          if ($link && $link.length) {
            $link.attr('href', zoomUrl || $link.attr('href'));
          }
        } catch (e) { /* ignore */ }

        // メモ表示更新
        if (memo.trim() !== '') {
          $memo.text(memo).removeClass('Hidden').show();
        } else {
          $memo.text('').addClass('Hidden').hide();
        }
      });
    });
  })(jQuery);

  /*
  #=============================================================
  # Remodalギャラリー初期化
  #=============================================================
  */
  (function ($) {
    $(function () {
      var $modal = $('[data-remodal-id="modal_zoomImg"]');
      var remodalInst = $modal.remodal();
      var $zoomImg = $('#ZoomImg');
      var $zoomText = $('#ZoomText');
      var $prevBtn = $('#ModalPrevBtn');
      var $nextBtn = $('#ModalNextBtn');

      var fallbackZoom = '<?= h($fallbackZoom) ?>';
      var currentIndex = 0;

      function preload(src, done, fail) {
        var img = new Image();
        img.onload = function () { done && done(); };
        img.onerror = function () { fail && fail(); };
        img.src = src;
      }

      function getModalThumbs() {
        return $('#ModalThumbnail .ModalThumbBtn');
      }

      function getPageThumbs() {
        return $('#Thumbnail .ThumbBtn');
      }

      function swapModalMain($btn) {
        var zoom = $btn.data('zoom') || fallbackZoom;
        var memo = ($btn.data('memo') || '').toString();
        var alt = ($btn.data('alt') || '').toString();

        getModalThumbs().removeClass('is-active');
        $btn.addClass('is-active');

        $zoomText.text(memo);
        $zoomImg.attr('alt', alt);

        preload(zoom, function () { $zoomImg.attr('src', zoom); },
          function () { $zoomImg.attr('src', fallbackZoom); });
      }

      function goTo(idx) {
        var $modalThumbs = getModalThumbs();
        var maxIndex = Math.max(0, $modalThumbs.length - 1);
        if (idx < 0) idx = maxIndex;
        if (idx > maxIndex) idx = 0;
        currentIndex = idx;
        var $target = $modalThumbs.filter('[data-index="' + idx + '"]').first();
        if ($target.length) {
          swapModalMain($target);
          var container = document.querySelector('.RemodalGallery__thumbs');
          var btnEl = $target.get(0);
          if (container && btnEl && btnEl.scrollIntoView) {
            btnEl.scrollIntoView({ block: 'nearest' });
          }
        }
      }

      function getPageActiveIndex() {
        var $active = getPageThumbs().filter('.is-active').first();
        var idx = parseInt(($active.data('index') || 0), 10);
        if (isNaN(idx)) idx = 0;
        var $modalThumbs = getModalThumbs();
        var maxIndex = Math.max(0, $modalThumbs.length - 1);
        return Math.max(0, Math.min(idx, maxIndex));
      }

      $(document)
        .off('click.remodalopen', '#MainPhotoLink')
        .on('click.remodalopen', '#MainPhotoLink', function (e) {
          e.preventDefault();
          // ページ側の現在選択写真から拡大URL/テキストを取得
          var $activePageThumb = getPageThumbs().filter('.is-active').first();
          var zoomUrl = ($activePageThumb.data('zoom')) || $('#MainPhotoLink').attr('href') || fallbackZoom;
          var memo    = ($activePageThumb.data('memo') || '').toString();
          var alt     = ($activePageThumb.data('alt')  || $('#MainPhoto').attr('alt') || '').toString();

          // 画像とテキスト適用
          $zoomText.text(memo);
          $zoomImg.attr('alt', alt);
          preload(zoomUrl, function(){ $zoomImg.attr('src', zoomUrl); }, function(){ $zoomImg.attr('src', fallbackZoom); });

          // モーダルを開く（サムネ無しのためgoToは使用しない）
          remodalInst.open();
        });

      $(document).off('click.remodalthumb').on('click.remodalthumb', '.ModalThumbBtn', function () {
        var $btn = $(this);
        var idx = parseInt(($btn.data('index') || 0), 10);
        if (!isNaN(idx)) currentIndex = idx;
        swapModalMain($btn);
      });

      $prevBtn.on('click', function () { goTo(currentIndex - 1); });
      $nextBtn.on('click', function () { goTo(currentIndex + 1); });

      $(document).on('keyup', function (ev) {
        if (!$('html').hasClass('remodal-is-locked')) return;
        // サムネイルが無い場合は左右キーを無効化
        if (getModalThumbs().length === 0) return;
        if (ev.key === 'ArrowLeft') { goTo(currentIndex - 1); }
        if (ev.key === 'ArrowRight') { goTo(currentIndex + 1); }
      });

      $(document).off('click.pagethumb').on('click.pagethumb', '#Thumbnail .ThumbBtn', function () {
        var idx = parseInt(($(this).data('index') || 0), 10);
        if (!isNaN(idx)) currentIndex = idx;
      });
    });
  })(jQuery);

  /*
  #=============================================================
  # かごに入れる Ajax処理
  #=============================================================
  */
  function bindAddCartForm(options) {
    var opts = $.extend({
      form: 'form[name="AddCartForm"]',
      quantitySelector: '[name="ItemNum"]'
    }, options || {});

    function normalizeInt(v, def) {
      var n = parseInt(String(v == null ? '' : v).replace(/[^\d\-]/g, ''), 10);
      return isFinite(n) && n > 0 ? n : (def || 1);
    }

    function findInForm($form, selector) {
      var $t = $form.find(selector);
      if ($t.length) return $t;
      var id = $form.attr('id');
      if (id) {
        $t = $(selector + '[form="' + id.replace(/(["\\])/g, '\\$1') + '"]');
        if ($t.length) return $t;
      }
      return $();
    }

    function resolveItemNum($form, $btn) {
      var $t, sel;
      if (opts.quantitySelector) {
        $t = findInForm($form, opts.quantitySelector);
        if ($t.length) return normalizeInt($t.val());
      }
      if ($btn && $btn.length) {
        sel = $btn.data('quantitySelector');
        if (sel) {
          $t = findInForm($form, sel);
          if ($t.length) return normalizeInt($t.val());
        }
        var dq = $btn.data('quantity') || $btn.data('qty');
        if (dq != null && dq !== '') return normalizeInt(dq);
      }
      var candidates = [
        '[name="ItemNum"]', '[name="ItemNumKe"]', '.final-quantity-input',
        '[name="itemNum"]', '[name="quantity"]', '[name="itemNum"]',
        '[name="Qty"]', '[name="item_num"]'
      ];
      for (var i = 0; i < candidates.length; i++) {
        $t = findInForm($form, candidates[i]);
        if ($t.length) return normalizeInt($t.val());
      }
      $t = findInForm($form, 'input[type="number"]:visible:first');
      if ($t.length) return normalizeInt($t.val());
      $t = findInForm($form, 'select:visible:first');
      if ($t.length) return normalizeInt($t.val());
      return 1;
    }

    function sendAjax($form, $triggerBtn) {
      if (!$form || !$form.length) return;

      var sku = findInForm($form, 'input[name="sku"]').val();
      var itemName = findInForm($form, 'input[name="itemName"]').val();
      var itemNum = resolveItemNum($form, $triggerBtn);

      var $cartBtn = $triggerBtn && $triggerBtn.length
        ? $triggerBtn : $form.find('.CartBtn').first();

      var itemCode = $cartBtn.data('goods_id');
      var itemCopy = $cartBtn.data('copy');
      var itemBulletPoint = $cartBtn.data('bulletpoint');
      var itemPict1Memo = $cartBtn.data('pict1_memo');
      var itemVariKey = $cartBtn.data('varikey');
      var itemVariVal = $cartBtn.data('varival');

      $.ajax({
        url: '/cart/_ajax_addlogic.html',
        type: 'POST',
        dataType: 'json',
        data: { sku: sku, itemNum: itemNum }
      }).done(function (response) {
        if (response && response.result === 'success') {
          $('.HeadCartNum').addClass('FCPriceRed').text(response.cartNum);
          $('#modalAddItemName').text(itemName || '');
          $('#modalAddItemNum').text(itemNum || '');
          $('#modalAddMoreData').html(response.modalHtml || '');
          $('#modalAddItemCatalogInfo').text(itemCode || '');
          if (itemVariKey && itemVariVal) {
            $('#modalAddItemVariKeyAndValue').text(String(itemVariKey) + '：' + String(itemVariVal));
          } else {
            $('#modalAddItemVariKeyAndValue').text('');
          }
          if (itemCopy) {
            $('#modalAddItemBulletPoint').html('<div class="FCDarkGreen FS110">' + String(itemCopy) + '</div>');
          } else if (itemBulletPoint) {
            $('#modalAddItemBulletPoint').html('<div class="M5T">' + String(itemBulletPoint) + '</div>');
          } else {
            $('#modalAddItemBulletPoint').html('');
          }
          if (itemPict1Memo) {
            $('#modalAddItemPict1Memo').html('<div class="M5T">' + String(itemPict1Memo) + '</div>');
          } else {
            $('#modalAddItemPict1Memo').html('');
          }
          if ($cartBtn && $cartBtn.length) {
            $cartBtn.removeClass('blueBtn').addClass('defaultBtn').val('追加しました');
          }
          if ($.fn.remodal) {
            try { $('[data-remodal-id=modal_addCart]').remodal().open(); } catch (e) { }
          }
        } else {
          alert((response && response.message) || 'エラーが発生しました。');
        }
      }).fail(function (xhr) {
        console.error(xhr && xhr.status, xhr && xhr.responseText);
        alert('通信エラーが発生しました。もう一度お試しください。');
      });
    }

    $(document).off('submit.addcart').on('submit.addcart', opts.form, function (e) {
      e.preventDefault();
      var $form = $(this);
      var $btnFocused = $form.find('.CartBtn:focus');
      sendAjax($form, $btnFocused.length ? $btnFocused : null);
      return false;
    });

    $(document).off('click.addcart').on('click.addcart', '.CartBtn', function (e) {
      var $btn = $(this);
      var $form = $btn.closest('form');
      if ($form.length) {
        e.preventDefault();
        sendAjax($form, $btn);
        return false;
      }
    });
  }

  /*
  #=============================================================
  # 配送料UI（セレクト／テーブル読込）
  #=============================================================
  */
  function bindShippingUI() {

    //======================================
    // 送料セレクトメニュー
    //======================================
    $(document)
      .off('change.shipui', 'select[name="shipAreaId"]')
      .on('change.shipui', 'select[name="shipAreaId"]', function () {
        var shipAreaId = $(this).val();
        if (shipAreaId == null || shipAreaId === '') return;

        $.get('/item/change-ship-select.html?shipAreaId=' + encodeURIComponent(shipAreaId))
          .done(function () {
            //alert('配送エリアを変更しました。ページを更新してください。');
            // 自動更新したい場合は↓を有効化
            window.location.reload();
          })
          .fail(function (xhr) {
            console.error('change-ship-select failed', xhr && xhr.status, xhr && xhr.responseText);
            alert('配送エリアの反映に失敗しました。時間をおいて再度お試しください。');
          });
      });
  }




  /*
  #=============================================================
  # レビュー「次の◯件」読み込み（Ajaxでappend）
  # $("#LoadMoreReviewsBtn") クリック → JSON受信 → #ReviewList に追加
  #=============================================================
  */
  function bindReviewLoadMore() {
    var currentXhr = null;
    var ns = '.reviewload';

    // 既存バインド解除
    $(document).off('click' + ns, '#LoadMoreReviewsBtn');

    //=============================================================
    // 次のレビュー取得
    // $("#LoadMoreReviewsBtn").on("click", ...)
    // 返却JSON: {status:"ok", html:"<li>…</li>…", nextOffset:int, nextCount:int, hasMore:bool, total:int, added:int}
    //=============================================================
    $(document).on('click' + ns, '#LoadMoreReviewsBtn', function (e) {
      e.preventDefault();

      var $btn = $(this);
      // 連打防止
      if ($btn.hasClass('is-loading') || $btn.attr('aria-disabled') === 'true') return;

      var endpoint  = String($btn.data('endpoint') || '');
      var type      = String($btn.data('type') || '');
      var id        = String($btn.data('id') || '');
      var offset    = parseInt($btn.data('offset') || 1, 10);
      var limit     = parseInt($btn.data('limit') || 10, 10);
      var hasCom    = parseInt($btn.data('has-comment') || 0, 10);
      var targetSel = String($btn.data('target') || '#ReviewList');
      var hasMore   = String($btn.data('has-more') || '1') === '1';

      var $list  = $(targetSel);
      var $load  = $('#ReviewLoading');
      var $err   = $('#ReviewLoadError');
      var $voice = $('#ReviewAnnounce');

      if (!endpoint || !type || !id || !$list.length || !hasMore) return;

      // 前回通信が残っていたら中断
      if (currentXhr && currentXhr.abort) {
      try {
        console.warn('Aborting previous review load XHR', {
        url: currentXhr && currentXhr.url || undefined,
        readyState: currentXhr && currentXhr.readyState || undefined
        });
        currentXhr.abort();
      } catch (e) {
        console.warn('Error aborting previous review load XHR', e);
      }
      currentXhr = null;
      }

      // 表示更新
      $err.hide().text('');
      $load.show();
      $list.attr('aria-busy', 'true');
      $btn.addClass('is-loading').attr('aria-disabled', 'true');

      // 通信
      currentXhr = $.ajax({
      url: endpoint,
      method: 'GET',
      dataType: 'json',
      data: {
        type: type,
        id: id,
        offset: offset,
        limit: limit,
        hasComment: hasCom
      }
      });

      currentXhr.done(function (res) {
      if (!res || res.status !== 'ok') {
        var msg = (res && res.message) ? String(res.message) : '読み込みに失敗しました。';
        // 詳細ログ
        console.error('LoadMoreReviews: invalid response', {
        endpoint: endpoint,
        request: { type: type, id: id, offset: offset, limit: limit, hasComment: hasCom },
        response: res
        });
        $err.text(msg).show();
        return;
      }

      // HTML追加
      if (res.html) {
        $list.append(res.html);
      }

      // ボタン状態を更新
      var nextOffset = parseInt(res.nextOffset || (offset + limit), 10);
      var nextCount  = parseInt(res.nextCount  || 0, 10);
      var nextHas    = !!res.hasMore;

      $btn.data('offset', nextOffset);
      $btn.data('has-more', nextHas ? '1' : '0');

      if (nextHas && nextCount > 0) {
        $btn.text('次の' + nextCount + '件を読み込む').show();
      } else {
        $btn.hide();
      }

      // 読み上げ（A11y）
      if (res.added && res.added > 0) {
        $voice.html('<p class="Cnt">' + res.added + '件のレビューを追加しました。</p>');
      }
      }).fail(function (jqXHR, textStatus, errorThrown) {
      // 詳細コンソールログ
      try {
        var respText = jqXHR && jqXHR.responseText;
        var parsed = null;
        try { parsed = respText ? JSON.parse(respText) : null; } catch (e) { /* ignore */ }

        /*
        console.error('LoadMoreReviews AJAX failed', {
        url: endpoint,
        request: { type: type, id: id, offset: offset, limit: limit, hasComment: hasCom },
        status: jqXHR && jqXHR.status,
        statusText: jqXHR && jqXHR.statusText,
        textStatus: textStatus,
        errorThrown: errorThrown,
        responseText: respText,
        parsedResponse: parsed
        });
        */
      } catch (e) {
        console.error('LoadMoreReviews fail handler error', e);
      }

      $err.text('通信に失敗しました。時間をおいて再度お試しください。').show();
      }).always(function () {
      $load.hide();
      $list.attr('aria-busy', 'false');
      $btn.removeClass('is-loading').attr('aria-disabled', 'false');
      });
    });
  }

  //=============================================================
  // 初期化
  //=============================================================
  $(function () {
    bindAddCartForm();
    bindShippingUI();
    bindReviewLoadMore();
  });

})(window, window.jQuery);
